export default __webpack_public_path__ + "static/Electronics-Removal-882dbe70d32092937b200df1f54a8368.jpg";